import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { BsInfoCircle } from 'react-icons/bs';

export const GridTable = ({
    type,
    content,
    responseData,
    handleOptionsChange
}) => {

    const handleOptionsChecked = (optionId) => {
        if (type === 'SUBMIT_RESPONSE') {
            return responseData?.gridResponses?.some(response => response.cellOption?.id === optionId);
        } else {
            return responseData?.some(data =>
                data.gridResponses?.some(response =>
                    response.cellOption?.id === optionId
                )
            );
        }
    }
    return (
        <div className=' RadioGridTable'>
            {content.gridConfig?.rows
                ?.sort((a, b) => a.sortOrder - b.sortOrder)
                .map(row => (
                    <div className='mt-3' key={row.id}>
                        <h6>{row.name}
                            {
                                row.helpText &&
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Popover id="popover-trigger-hover-focus" className="p-2">
                                            <div className="p-1">{row.helpText}</div>
                                        </Popover>
                                    }>
                                    <span className='mx-2 cursor'> <BsInfoCircle /></span>
                                </OverlayTrigger>
                            }
                        </h6>
                        <ul>
                            {content.gridConfig.columns?.sort((a, b) => a.sortOrder - b.sortOrder)
                                .map((col, index) => (

                                    row.cellOptions?.filter(option => option.columnId === col.id)?.sort((a, b) => a.sortOrder - b.sortOrder)
                                        .map(option => (
                                            <li className='inline-1' key={col.id}>
                                                <div className='form-check form-check-inline'>
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name={`row-${row.id}`}
                                                        id={option.id}
                                                        value={option.id}
                                                        checked={handleOptionsChecked(option.id)}
                                                        disabled={type === 'BUILD' || type === 'SUBMIT_RESPONSE'}
                                                        onChange={(e) => {
                                                            if (type !== 'BUILD') {
                                                                handleOptionsChange(e);
                                                            }
                                                        }}
                                                    />
                                                    <label key={option.id} for={option.id}>
                                                        {/* <span>{index++}</span> */}
                                                        {option.name}
                                                    </label>
                                                </div>
                                            </li>


                                        ))
                                ))}
                        </ul>
                    </div>
                ))}
        </div>


    );
};

export default GridTable;
